module.exports = __webpack_public_path__ + "img/tax.83e9387d.png";